import { render } from "./page-private.vue?vue&type=template&id=51d9e224&scoped=true"
import script from "./page-private.vue?vue&type=script&lang=js"
export * from "./page-private.vue?vue&type=script&lang=js"

import "./page-private.vue?vue&type=style&index=0&id=51d9e224&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d9e224"]])

export default __exports__